import { mixed, object, string, ObjectSchemaDefinition } from 'yup'
import { FormLongTextInput, FormTextInput } from '@superhi/design'
import { FieldConfig } from '@superhi/utils'

import InputImage from '../../../../../components/InputImage'

import { FormValues } from './types'

const DESCRIPTION: FieldConfig<typeof FormLongTextInput> = {
  ariaLabel: 'Description',
  label: 'Description',
  name: 'description',
  placeholder: 'E.g.',
  height: 6,
}

const FINISHED_URL: FieldConfig<typeof FormTextInput> = {
  ariaLabel: 'Finished URL',
  label: 'Finished URL',
  name: 'finishedUrl',
  type: 'url',
  placeholder: 'E.g.',
}

const BRIEF_URL: FieldConfig<typeof FormTextInput> = {
  ariaLabel: 'Brief URL',
  label: 'Brief URL',
  name: 'briefUrl',
  type: 'url',
  placeholder: 'E.g.',
}

const IMAGE: FieldConfig<typeof InputImage> = {
  label: 'Image',
  ariaLabel: 'Image',
  name: 'image',
  required: true,
}

const SLUG: FieldConfig<typeof FormTextInput> = {
  ariaLabel: 'Slug',
  label: 'Slug',
  name: 'slug',
  placeholder: 'E.g.',
  required: true,
}

const TITLE: FieldConfig<typeof FormTextInput> = {
  ariaLabel: 'Title',
  label: 'Title',
  name: 'title',
  placeholder: 'E.g.',
  required: true,
}

export const FIELDS = {
  DESCRIPTION,
  FINISHED_URL,
  BRIEF_URL,
  IMAGE,
  SLUG,
  TITLE,
}

export const VALIDATION_SCHEMA: ObjectSchemaDefinition<FormValues> = {
  description: string(),
  finishedUrl: string(),
  image: object({
    url: string(),
    value: string().required(),
    file: mixed().required(),
  }).required(),
  slug: string().required(),
  title: string().required(),
  briefUrl: string(),
}
